module.exports = __webpack_public_path__ + "static/media/modicogryllus_frontalis.e0886121.jpg";